/* You Fly LA · homepage "Runway HUD" header + hero (v68, 2026-10-15, BUILD-HUD; design hero4/designs/3-runway-hud).
   Loaded with defer by sections/yh-hud-header.liquid and sections/yh-hud-hero.liquid (homepage only); runs once.
   Header: live Van Nuys clock + Open Now (9 AM - 9 PM, 7 days, America/Los_Angeles), row 1 scrolls away (the compact
   state is read from the strip's position, so it works whether the window or Horizon's .page-wrapper scrolls),
   mega-menus from 1200px (hover intent, click, Escape, arrow keys, outside click), Menu drawer below 1200px.
   Hero: Pause/Play, off-screen pause, reduced motion / Save-Data (no autoplay, poster + Play), phone-crop source check,
   HUD On/Off (remembered per viewer), caption chip, the Who's Flying x minutes picker (price, sub line, Book link, HUD
   tag), price tiles -> window.YH.courses.select (assets/yh-home.js) as before.
   Booking links keep /products/ paths; when the picker changes one, the calendar stamp assets/yfla-book.js left on it
   is dropped and the link is swept again (the same helper as assets/yh-home.js setHref), so the weight/terms gate
   (snippets/yfla-consent-gate.liquid) still runs first. Nothing here calls preventDefault on a link. Global:
   window.YH_HUD only. */
(function () {
  'use strict';
  if (window.YH_HUD) return;
  window.YH_HUD = { version: 'v68' };
  var d = document, root = d.documentElement;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false, addListener: function () {} }; };
  var onMQ = function (m, fn) { if (m.addEventListener) m.addEventListener('change', fn); else if (m.addListener) m.addListener(fn); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  var mqDesk = mq('(min-width: 1200px)'), mqHover = mq('(hover: hover) and (pointer: fine)');
  var mqPhone = mq('(max-width: 699px)'), mqRM = mq('(prefers-reduced-motion: reduce)'), mq1080 = mq('(min-width: 1280px)');
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('yh-hud', e); } }
  function lockScroll(on) {
    root.style.overflow = on ? 'hidden' : '';
    if (on) root.setAttribute('scroll-lock', ''); else root.removeAttribute('scroll-lock');
  }
  /* wrap $ amounts in mono spans (menu descriptions and preview titles) */
  function money(el) {
    if (!el || el.getAttribute('data-rh-done')) return;
    el.setAttribute('data-rh-done', '1');
    var t = el.textContent;
    if (!/\$\d/.test(t)) return;
    var frag = d.createDocumentFragment(), re = /\$[\d,]+(?:\.\d+)?/g, last = 0, m;
    while ((m = re.exec(t))) {
      if (m.index > last) frag.appendChild(d.createTextNode(t.slice(last, m.index)));
      var s = d.createElement('span'); s.className = 'rh-m'; s.textContent = m[0]; frag.appendChild(s);
      last = m.index + m[0].length;
    }
    if (last < t.length) frag.appendChild(d.createTextNode(t.slice(last)));
    el.textContent = '';
    el.appendChild(frag);
  }

  /* =================================== HEADER =================================== */
  function initHeader() {
    var hdr = $('#rh-hdr');
    if (!hdr) return;
    var hdrA = $('.rh-hdr-a', hdr), hdrB = $('.rh-hdr-b', hdr);
    $$('[data-rh-money]', hdr).forEach(money);

    /* 1. live Van Nuys clock + office annunciator (9 AM to 9 PM, 7 days) */
    var clk = $('#rh-clk'), tz = $('#rh-tz'), ann = $('#rh-ann'), annTx = $('#rh-annTx');
    var tf = null, hf = null;
    try {
      tf = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true, timeZoneName: 'short' });
      hf = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', hourCycle: 'h23' });
    } catch (e) { tf = null; }
    function tick() {
      if (!tf || !clk) return;
      var now = new Date(), p = {};
      tf.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
      var h = parseInt(hf.format(now), 10) % 24;
      clk.innerHTML = p.hour + ':' + p.minute + '<span class="rh-sec">:' + p.second + '</span> ' + String(p.dayPeriod || '').toUpperCase();
      if (tz) tz.textContent = p.timeZoneName || 'PT';
      var open = h >= 9 && h < 21, state = open ? 'open' : 'closed';
      if (ann && ann.getAttribute('data-state') !== state) {
        ann.setAttribute('data-state', state);
        annTx.textContent = open ? 'Open Now' : 'Opens 9 AM';
      }
    }
    tick();
    if (tf) setInterval(tick, 1000);

    /* 2. compact header once row 1 has scrolled away (window or .page-wrapper, whichever scrolls) */
    var compact = null, ticking = false;
    function onScroll() {
      ticking = false;
      var c = hdrA.getBoundingClientRect().bottom <= 2;
      if (c !== compact) { compact = c; hdr.classList.toggle('is-compact', c); }
    }
    var req = function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } };
    d.addEventListener('scroll', req, { capture: true, passive: true });
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    onScroll();

    /* 3. mega-menus (1200px and up) and the drawer with accordions (below) */
    var nav = $('#rh-nav'), mbtn = $('#rh-mbtn'), ind = $('#rh-navInd'), list = $('#rh-navList');
    var items = $$('.rh-nv-i[data-mm]', nav);
    var hoverT = null;
    function setTop() {
      var b = Math.max(0, Math.round(hdrB.getBoundingClientRect().bottom));
      hdr.style.setProperty('--rh-mmtop', b + 'px');
      nav.style.setProperty('--rh-dtop', b + 'px');
    }
    function anyOpen() { return items.some(function (o) { return o.classList.contains('is-open'); }); }
    function moveInd(btn) {
      if (!ind || !mqDesk.matches) return;
      if (!btn) { ind.style.opacity = '0'; ind.style.transform = (ind.style.transform || '').replace(/scaleX\([^)]*\)/, 'scaleX(0)'); return; }
      var r = btn.getBoundingClientRect(), base = hdrB.getBoundingClientRect();
      var pad = window.innerWidth < 1366 ? 7 : (window.innerWidth < 1440 ? 9 : 11);
      var x = r.left - base.left + pad, w = Math.max(1, r.width - pad * 2);
      ind.style.transform = 'translateX(' + x + 'px) scaleX(' + w + ')';
      ind.style.opacity = '1';
    }
    function loadImgs(li) {
      if (!mqDesk.matches) return;
      $$('img[data-src]', li).forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
    }
    function closeItem(li) {
      if (!li.classList.contains('is-open')) return;
      li.classList.remove('is-open');
      $('.rh-nv-t', li).setAttribute('aria-expanded', 'false');
    }
    function openItem(li) {
      items.forEach(function (o) { if (o !== li) closeItem(o); });
      var b = $('.rh-nv-t', li);
      li.classList.add('is-open');
      b.setAttribute('aria-expanded', 'true');
      setTop(); loadImgs(li); moveInd(b);
    }
    function closeAll() { items.forEach(closeItem); moveInd(null); }
    items.forEach(function (li) {
      var b = $('.rh-nv-t', li);
      b.addEventListener('click', function () {
        clearTimeout(hoverT);
        if (li.classList.contains('is-open')) {
          if (Date.now() - (li.__hoverAt || 0) < 600) return; /* opened by hover a moment ago: the click keeps it open */
          closeItem(li); moveInd(null);
        } else { openItem(li); }
      });
      li.addEventListener('pointerenter', function (e) {
        if (!mqDesk.matches || !mqHover.matches || e.pointerType !== 'mouse') return;
        clearTimeout(hoverT);
        hoverT = setTimeout(function () { if (!li.classList.contains('is-open')) { openItem(li); li.__hoverAt = Date.now(); } }, anyOpen() ? 40 : 110);
      });
      li.addEventListener('pointerleave', function (e) {
        if (!mqDesk.matches || !mqHover.matches || e.pointerType !== 'mouse') return;
        clearTimeout(hoverT);
        hoverT = setTimeout(function () { closeItem(li); if (!anyOpen()) moveInd(null); }, 220);
      });
    });
    $$('.rh-nv-i > a.rh-nv-t', nav).forEach(function (a) {
      a.addEventListener('pointerenter', function () { if (mqDesk.matches && mqHover.matches && !anyOpen()) moveInd(a); });
      a.addEventListener('pointerleave', function () { if (mqDesk.matches && !anyOpen()) moveInd(null); });
    });
    d.addEventListener('click', function (e) {
      if (mqDesk.matches && anyOpen() && !(e.target.closest && e.target.closest('#rh-nav'))) closeAll();
    });
    /* a link chosen inside a mega-menu or the drawer closes it (the page may not navigate: #enroll, tel:, the gate) */
    nav.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (nav.classList.contains('is-open')) setDrawer(false);
      else closeAll();
    });
    function setDrawer(open) {
      if (open) setTop();
      nav.classList.toggle('is-open', open);
      mbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      $('.rh-mbtn__tx', mbtn).textContent = open ? 'Close' : 'Menu';
      $('.rh-mbtn__sr', mbtn).textContent = open ? 'Close Menu' : 'Menu';
      lockScroll(open);
      if (open) { var f = $('.rh-nv-t', nav); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (x) {} }, 60); }
      else closeAll();
    }
    mbtn.addEventListener('click', function () { setDrawer(!nav.classList.contains('is-open')); });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open = items.filter(function (o) { return o.classList.contains('is-open'); })[0];
      if (mqDesk.matches && open) { closeItem(open); moveInd(null); $('.rh-nv-t', open).focus(); return; }
      if (nav.classList.contains('is-open')) { setDrawer(false); mbtn.focus(); }
    });
    list.addEventListener('keydown', function (e) {
      if (!mqDesk.matches || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var tops = $$('.rh-nv-t', nav), i = tops.indexOf(d.activeElement);
      if (i < 0) return;
      e.preventDefault();
      tops[(i + (e.key === 'ArrowRight' ? 1 : -1) + tops.length) % tops.length].focus();
    });
    onMQ(mqDesk, function () { if (nav.classList.contains('is-open')) setDrawer(false); closeAll(); });
    window.addEventListener('resize', function () {
      var o = items.filter(function (x) { return x.classList.contains('is-open'); })[0];
      if (o && mqDesk.matches) moveInd($('.rh-nv-t', o));
      setTop();
    });
    setTop();
  }

  /* ==================================== HERO ==================================== */
  function initHero() {
    var hero = $('#rh-hero');
    if (!hero) return;
    var stage = $('#rh-stage', hero);

    /* 4. video: Pause/Play, reduced motion / Save-Data, off-screen pause, wrong-source fallback */
    var v = $('#rh-hv', hero), pb = $('#rh-playB', hero), ptx = $('#rh-playTx', hero);
    if (v && pb) {
      var noAuto = v.getAttribute('data-noauto') === '1' || mqRM.matches;
      var userPaused = noAuto;
      if (noAuto) { v.removeAttribute('autoplay'); v.autoplay = false; try { v.pause(); } catch (x) {} }
      var sync = function () {
        var paused = v.paused;
        pb.setAttribute('data-state', paused ? 'paused' : 'playing');
        pb.setAttribute('aria-label', paused ? 'Play Video' : 'Pause Video');
        if (ptx) ptx.textContent = paused ? 'Play' : 'Pause';
      };
      var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () { sync(); }); };
      /* a browser that ignores <source media> may pick the phone crop on a desktop or the 1080p file on a small
         screen: drop the sources that do not match and load again */
      var fixed = false;
      var checkSrc = function () {
        var cur = v.currentSrc || '';
        if (!cur || fixed) return;
        var src = $$('source', v).filter(function (s) { return s.src === cur; })[0];
        var k = src ? src.getAttribute('data-k') : '';
        var wrong = (k === 'm' && !mqPhone.matches) || (k === '1080' && !mq1080.matches);
        if (!wrong) return;
        fixed = true;
        $$('source[media]', v).forEach(function (s) { if (!mq(s.media).matches) s.parentNode.removeChild(s); });
        v.load();
        if (!userPaused) tryPlay();
      };
      v.addEventListener('loadstart', checkSrc);
      setTimeout(checkSrc, 0);
      ['play', 'pause', 'playing'].forEach(function (ev) { v.addEventListener(ev, sync); });
      pb.addEventListener('click', function () {
        if (v.paused) { userPaused = false; tryPlay(); } else { userPaused = true; v.pause(); }
      });
      if (!noAuto) tryPlay();
      sync();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var inView = en[0].isIntersecting;
          if (!inView && !v.paused) { v.pause(); v.__auto = true; }
          else if (inView && v.__auto && !userPaused) { v.__auto = false; tryPlay(); }
        }, { threshold: 0.05 }).observe(stage);
      }
      onMQ(mqPhone, function () { var p = v.getAttribute(mqPhone.matches ? 'data-poster-m' : 'data-poster'); if (p) v.setAttribute('poster', p); });
    }

    /* 5. HUD On / Off (remembered per viewer) */
    var hudB = $('#rh-hudB', hero), hudSt = $('#rh-hudSt', hero), tag = $('#rh-tag', hero);
    function setHud(on, save) {
      stage.classList.toggle('rh-hud-off', !on);
      hudB.setAttribute('aria-pressed', on ? 'true' : 'false');
      hudSt.textContent = on ? 'On' : 'Off';
      if (tag) { if (on) { tag.removeAttribute('tabindex'); tag.removeAttribute('aria-hidden'); } else { tag.setAttribute('tabindex', '-1'); tag.setAttribute('aria-hidden', 'true'); } }
      if (save) store.set('yfla-hud', on ? '1' : '0');
    }
    if (hudB && hudSt) {
      setHud(store.get('yfla-hud') !== '0', false);
      hudB.addEventListener('click', function () { setHud(hudB.getAttribute('aria-pressed') !== 'true', true); });
    }

    /* 6. caption chip */
    var capB = $('#rh-capB', hero), capP = $('#rh-capP', hero);
    function toggleCap(open) {
      if (!capB || !capP) return;
      capP.classList.toggle('is-open', open);
      capB.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (capB) {
      capB.addEventListener('click', function () { toggleCap(capB.getAttribute('aria-expanded') !== 'true'); });
      d.addEventListener('click', function (e) { if (capB.getAttribute('aria-expanded') === 'true' && !(e.target.closest && e.target.closest('#rh-cap'))) toggleCap(false); });
      d.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && capB.getAttribute('aria-expanded') === 'true') { toggleCap(false); capB.focus(); }
      });
    }

    /* 7. booking row: who + minutes drive the price, the sub line, the Book link and the HUD tag */
    var M = null;
    try { M = JSON.parse(($('#rh-matrix', hero) || {}).textContent || 'null'); } catch (e) { M = null; }
    var bkA = $('#rh-bkA', hero), bkSub = $('#rh-bkSub', hero), bkGo = $('#rh-bkGo', hero), tagT = $('#rh-tagT', hero), live = $('#rh-bkLive', hero);
    if (M && M.matrix && bkA && bkGo) {
      var tagTarget = tagT ? tagT.textContent : '', tagTimer = null;
      var val = function (n) { var r = $('input[name="' + n + '"]:checked', hero); return r ? r.value : null; };
      /* point a booking link at another product: drop the calendar stamp yfla-book.js left on it, then sweep again */
      var setHref = function (a, href) {
        if (!a || a.getAttribute('data-rh-href') === href) return;
        ['data-yfla-cal', 'data-cowlendar-btn', 'data-yfla-handle', 'data-yfla-nocal'].forEach(function (k) { a.removeAttribute(k); });
        a.setAttribute('data-rh-href', href);
        a.setAttribute('href', href);
        if (typeof window.YFLA_bookSweep === 'function') window.YFLA_bookSweep(a.parentNode || d);
      };
      var swapGo = function (price) {
        var cur = $$('span', bkGo).filter(function (x) { return !x.classList.contains('is-out'); });
        var last = cur[cur.length - 1];
        if (last && last.textContent === price) return;
        if (mqRM.matches || !last) { bkGo.innerHTML = ''; var s0 = d.createElement('span'); s0.textContent = price; bkGo.appendChild(s0); return; }
        $$('span.is-out', bkGo).forEach(function (x) { x.parentNode.removeChild(x); });
        var nu = d.createElement('span');
        nu.textContent = price;
        nu.style.transform = 'translateY(100%)'; nu.style.opacity = '0';
        cur.forEach(function (x) { x.style.position = 'absolute'; x.style.left = '0'; x.style.top = '0'; });
        bkGo.appendChild(nu);
        void nu.offsetWidth;
        cur.forEach(function (x) { x.classList.add('is-out'); });
        nu.style.transform = ''; nu.style.opacity = '';
        setTimeout(function () { cur.forEach(function (x) { if (x.parentNode) x.parentNode.removeChild(x); }); }, 340);
      };
      var first = true;
      var update = function (announce) {
        var who = val('rh-who') || 'me', dm = val('rh-dur') || '60';
        var row = (M.matrix[dm] || M.matrix['60'])[who], price = row[0], href = row[1];
        var parts = [dm + ' minutes', price].concat(who === 'me' ? ['you fly'] : ['you fly', 'your guest rides along']);
        bkSub.innerHTML = '';
        parts.forEach(function (x, i) {
          if (i) bkSub.appendChild(d.createTextNode(' · '));
          var s = d.createElement('span'); s.className = 'rh-nw'; s.textContent = x; bkSub.appendChild(s);
        });
        /* the Liquid hrefs are the 60-minute Just Me product (already swept by yfla-book.js): leave them on load
           unless the browser restored another choice */
        if (!(first && who === 'me' && dm === '60')) { setHref(bkA, href); setHref(tag, href); }
        first = false;
        swapGo(price);
        var label = (who === 'me' ? 'Discovery Flight' : 'Discovery Flight For Two') + ' · ' + dm + ' Min · ' + price;
        if (tagT && label !== tagTarget) {
          tagTarget = label;
          clearTimeout(tagTimer);
          if (mqRM.matches) tagT.textContent = label;
          else { tagT.classList.add('is-swap'); tagTimer = setTimeout(function () { tagT.textContent = tagTarget; tagT.classList.remove('is-swap'); }, 180); }
        }
        if (announce && live) live.textContent = (M.titles && M.titles[who] ? M.titles[who] : '') + ', ' + dm + ' minutes, ' + price;
      };
      $$('.rh-cfg input', hero).forEach(function (r) { r.addEventListener('change', function () { update(true); }); });
      update(false);
    }

    /* 8. price tiles: the program tiles also pick the program in the Courses section (as assets/yh-home.js did) */
    $$('.rh-tile[data-prog]', hero).forEach(function (t) {
      t.addEventListener('click', function () {
        var p = t.getAttribute('data-prog');
        if (window.YH && window.YH.courses && typeof window.YH.courses.select === 'function') {
          try { window.YH.courses.select(p, p === 'ppl' ? 1 : 0, 'pk'); } catch (e) {}
        }
      });
    });
  }

  function boot() { safe(initHeader); safe(initHero); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
